// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"c0111cbc","453":"c153058e","461":"8229c853"}[chunkId] + ".chunk.js";
};